import React from 'react';

import PropTypes from 'prop-types';

import BaseParameters from '../base/components/BaseParameters';
import { createFieldRegistry } from '../base/components/FieldRegistry';

const Parameters = ({ control, disabled, setValue, algorithmOptions }) => {
    const fields = createFieldRegistry({ control, disabled, setValue });

    const fieldsMappingByAlgorithm = {
        lease_api: [fields.apiKey],
        ppa_api_key: [fields.apiKey],
    };

    return (
        <BaseParameters
            algorithmOptions={algorithmOptions}
            control={control}
            disabled={disabled}
            fieldsMappingByAlgorithm={fieldsMappingByAlgorithm}
            setValue={setValue}
        />
    );
};

Parameters.propTypes = {
    algorithmOptions: PropTypes.array,
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default Parameters;
